import React from 'react';
import { makeStyles, Grid } from '@material-ui/core';

const QuestionText = (props) => {
    const classes = useStyles();

    return(
        <Grid container className={classes.root}>
            <Grid item className={classes.left}>
                <p>Q.</p>
            </Grid>
            <Grid item className={classes.right}>
                <p>{props.text}</p>
            </Grid>
        </Grid>
    );
};

const useStyles = makeStyles({
    root: {
        '& p': {
            fontSize: '14px',
            color: '#3b3f42',
            fontWeight: 'bold',
            letterSpacing: '-0.49px',
        },
    },
    left: {
        width: '6%',
    },
    right: {
        width: '94%',
    },
});

export default QuestionText;


